import type { MAGENTO_PAYMENT_METHOD_COMMON, MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY } from "@checkout-v2/shared";

export type PaymentStepFastFlowCandidate = {
  paymentMethodCode: string;
  magentoPaymentMethodType: typeof MAGENTO_PAYMENT_METHOD_COMMON | typeof MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY;
};

export type FastFlowPaymentStepCandidateReady = {
  paymentMethodCode: string;
  magentoPaymentMethodType: typeof MAGENTO_PAYMENT_METHOD_COMMON | typeof MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY;
};
